import React from 'react';
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Button,
    useDisclosure,
    Heading,
    VStack, Input, InputGroup, InputLeftAddon, useToast
} from '@chakra-ui/react';
import axios from "axios";
import { FormConsentFields } from '../../FormConsent/FormConsent';

export default function AppModal(props) {
    const toast = useToast();
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [name, setName] = React.useState("");
    const [phone, setPhone] = React.useState("");
    const [consentPd, setConsentPd] = React.useState(false);
    const [consentOferta, setConsentOferta] = React.useState(false);
    const [consentMarketing, setConsentMarketing] = React.useState(false);
    const [showConsentError, setShowConsentError] = React.useState(false);
    const [formError, setFormError] = React.useState("");

    const handleSend = async () => {
        if (!consentPd) {
            setFormError('Необходимо дать согласие на обработку персональных данных');
            setShowConsentError(true);
            return;
        }
        if (!consentOferta) {
            setFormError('Необходимо принять условия публичной оферты');
            setShowConsentError(true);
            return;
        }
        setFormError('');
        setShowConsentError(false);

        if (name.length < 2 || phone.length < 10) toast({
            position: 'bottom-right',
            title: `Введите корректные данные!`,
            status: 'warning',
            isClosable: true,
            containerStyle: {
                width: '350px'
            }
        }); else {
            toast({
                position: 'bottom-right',
                title: `Заявка отправлена!`,
                status: 'success',
                isClosable: true,
                containerStyle: {
                    width: '300px'
                }
            });
            onClose();
            await axios.post('https://api.twodev.cc/helper/septiki', {
                city: props.city.text ? props.city.text : props.city,
                info: `Главная страница / септики; септик: ${props.septik}; маркетинг: ${consentMarketing}`,
                name: name,
                phone: phone
            });
        };
    };

    return <>
        <Button colorScheme='yellow' color='white' onClick={onOpen}>КУПИТЬ СЕПТИК</Button>

        <Modal isOpen={isOpen} onClose={onClose} isCentered motionPreset='slideInBottom'>
            <ModalOverlay/>
            <ModalContent>
                <ModalHeader>Оформление</ModalHeader>
                <ModalCloseButton/>
                <ModalBody bgColor="gray.100">
                    <VStack p="30px" spacing="20px">
                        <Heading textAlign="center">{props.septik || "none"}</Heading>
                        <VStack w="100%">
                            <Input onChange={event => setName(event.target.value)} placeholder='Как к Вам обращаться?' color='black' bg='white' />
                            <InputGroup>
                                <InputLeftAddon children='+7'/>
                                <Input type='tel' onChange={event => setPhone(event.target.value)} placeholder='Ваш телефон' bg='white' color='black'/>
                            </InputGroup>
                            <FormConsentFields
                                theme="light"
                                consentPd={consentPd}
                                setConsentPd={setConsentPd}
                                consentOferta={consentOferta}
                                setConsentOferta={setConsentOferta}
                                consentMarketing={consentMarketing}
                                setConsentMarketing={setConsentMarketing}
                                showConsentError={showConsentError}
                                formError={formError}
                                onClearError={() => { setFormError(''); setShowConsentError(false); }}
                            />
                        </VStack>
                    </VStack>
                </ModalBody>

                <ModalFooter justifyContent="center">
                    <Button colorScheme='orange' isDisabled={!consentPd || !consentOferta} onClick={async () => { await handleSend(); }} w="80%">
                        Оформить заказ
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    </>
}
